import React from 'react';
import { Button } from '@canvas-logic/clp-shared-ui';
import { Popover } from '@/ui-kit/components/Popover';
import TooltipContainer from '@/ui-kit/components/Tooltip/TooltipContainer';
import { useTranslation } from 'react-i18next';
import { useGetPdf } from '@/ui-kit/hooks/use-get-pdf';

interface PdfDownloadButtonProps {}

type PdfDownloadButtonIcon = 'pdf' | 'spinner' | 'check';

const PdfDownloadButton: React.FC<PdfDownloadButtonProps> = () => {
  const { state, generate } = useGetPdf();
  const { t } = useTranslation('translation');

  const getButtonIcon = (): PdfDownloadButtonIcon => {
    switch (state) {
      case 'loading':
        return 'spinner';
      case 'ready':
        return 'check';
      default:
        return 'pdf';
    }
  };

  return (
    <Popover
      isDisabled={state !== 'ready'}
      content={<TooltipContainer>{t('buttons.pdfDownloadStarted')}</TooltipContainer>}
      animate
      initialIsOpen={true}
      trigger="none"
      placement="bottom"
      useProvidedRoot
    >
      <Button variant="ternary" onClick={generate} disabled={state === 'loading'} iconStart={getButtonIcon()} />
    </Popover>
  );
};

export default PdfDownloadButton;
